<div class="login-body">
    <p-toast position="top-center">
    </p-toast>
    <div class="login-panel">
        <div class="flex-col">
            <div>
                <img src="assets/layout/images/logo-login.png" />
                <h1>Passwort vergessen</h1>
                <h2>{{app.appName}}</h2>
            </div>
            <sm-form [form]="userName == null ? form1 : form2">
            </sm-form>
            @if (running) {
            <div>
                <div>Rücksetzung läuft ...</div>
                <p-progressSpinner></p-progressSpinner>
            </div>
            }
        </div>
    </div>
</div>